export default {
  title: 'Dashboard',
  description: `See how your content performs, and which channels drive the most engagement.`,
  text: {
    learn_more: 'Learn more.',
    contact_support: 'Talk to us',
    views: 'views',
    avg_time: 'avg time',
    total_views: 'Total Views',
    video_views: 'Video Views',
    video_views_for_video: 'Video Views for This Video',
    guide_views_for_guide: 'Guide views',
    total_embed_views: 'Total Video Views',
    unique_embed_views: 'Unique Video Views',
    total_guide_views: 'Total Guide View',
    unique_guide_views: 'Unique Guide View',
    learners: 'Learners',
    learners_for_video: 'Learners for This Video',
    learners_for_guide: 'Learners for this guide',
    new_learners: 'New Learners',
    total_hub_new_learners: 'Knowledge Hub - New Learners',
    top_videos: 'Top Videos',
    top_learning_path: 'Top Collections',
    engagement_metrics: 'Engagement Metric',
    engagement_duration: 'Engagement Duration',
    total_engagement_duration: 'Total Engagement Time',
    avg_engagement_duration: 'Average Engagement Time Per User',
    hub_avg_engagement_duration:
      'Knowledge Hub - Average Engagement Time Per User',
    range: 'Last 30 days',
    enrollments_copy: 'enrollments',
    completions_copy: 'completions',
    certified_copy: 'certifications',
    no_video_onboard:
      'Your dashboard seems empty! Start creating videos and train your customers!',
    share_video_onboard:
      'Your dashboard seems empty! Start sharing your videos!',
    start_sharing: 'Start sharing your collections!',
    start_sharing_videos: 'Start sharing your videos!',
    start_sharing_courses: 'Seems empty! Start sharing your courses!',
    note: 'Updated every 24 hours',
    video_analytics: 'Content Level Metrics',
    step_analytics: 'Video Block Level Drilled Down Metrics',
    chapter_analytics: 'Chapter Level Drilled Down Metrics',
    enrollments: 'Course Enrollments',
    completions: 'Course Completions',
    certifications: 'Certifications Issued',
    top_enrolled_courses: 'Top Enrolled Courses',
    top_certifications: 'Top Certified Courses',
    top_completed_courses: 'Top Completed Courses',
  },
  key_metrics: {
    title: 'Key Metrics',
    caption: 'A high-level view of learner engagement and training impact.',
    total_learners: 'Total Learners',
    total_learners_tooltip: 'Total learners in your workspace, including registered learners and anonymous viewers of your public content.',
    total_learners_cap: 'Across channels',
    active_learners: 'Engaged Learners',
    active_learners_tooltip: "Learners who have actively engaged with your content. Excludes registered learners who haven't started yet.",
    active_learners_cap: '% of total learners',
    total_views: 'Total Views',
    total_views_tooltip: 'Total number of times your content was viewed. Includes repeat views by same learners.',
    total_views_cap: 'views per learner avg',
    avg_learning_time: 'Avg Learning Time',
    avg_learning_time_tooltip: 'Average time an active learner spends engaging with your content.',
    avg_learning_time_cap: 'Per learner',
    total_learning_time: 'Self Serve Training',
    total_learning_time_tool_tip: 'Total hours of training your learners received through self-serve content, replacing live training sessions.',
    total_learning_time_cap: 'cost avoided (est)'
  },
  admin: {
    title: 'Admin & Creation Health',
    caption: "Track your team's content output, quality, and freshness in one view.",
    workspace_users: 'Workspace Users',
    workspace_users_cap: 'In workspace',
    published_content: 'Published Content',
    published_content_cap: 'Videos and guides',
    draft_content: 'Draft Content',
    draft_content_cap: 'Awaiting publication',
    content_score: 'Content Quality Score',
    content_score_cap: 'of learners liked your content',
    content_freshness: 'Content Freshness',
    content_feshness_tooltip: 'Percentage of your published content that has been updated in the last 180 days.',
    content_freshness_cap: 'Updated less than 180 days'
  },
  distribution_channel: {
    title: 'Content Performance by Channel',
    caption: 'See which distribution channel drives the highest engagement for your training content.',
    link: 'Shareable Links',
    learn_link: 'How to Share Links?',
    embed: 'Embeds',
    learn_embed: 'How to Embed Content?',
    embed_top_pages: 'Top Pages Via Embeds',
    embed_top_pages_cap: "See where your videos get watched most, across every page they're embedded on.",
    app_embed: 'In-App Tutorials',
    app_embed_disabled: 'Embed content inside your product, without code.',
    learn_app_embed: 'How to Create In-App Tutorials?',
    app_embed_top_pages: 'Top Pages by Tutorial Views',
    app_embed_top_pages_cap: 'Product pages where learners view your tutorials most.',
    hub: 'Knowledge Hub',
    hub_disabled: 'Build a branded knowledge base for self-serve training.',
    learn_hub: 'How to Setup Knowledge Hub?', 
    academy: 'Academy',
    academy_disabled: 'Turn your content into courses and structured learning paths.',
    learn_academy: 'How to Setup Academy?',
    enable: 'Get Started',
    empty: 'No data available for the selected date range.'
  },
  content_performance: {
    title: 'Content Performance',
    caption: "See what's working and what needs attention.",
    top_performing: 'Top Performing',
    top_performing_caption: 'Based on the selected date range.',
    need_attention: 'Needs Attention',
    need_attention_caption: 'Content with low engagement.',
    need_attention_tooltip: 'Tool-Tip: Based on last 30 days data.',
    empty_content: 'There’s no content available yet.'
  },
  guide_drop_off: {
    title: 'Guide Drop-Off',
    caption: 'Completion rate by guide length.',
    tooltip: 'Data based on average step completion across your 10 most-interacted guides.'
  },
  video_retention: {
    title: 'Video Retention',
    caption: 'See how long viewers stay engaged.',
    tooltip: 'Data based on average viewer engagement across your 10 most viewed videos.'
  },
  chart: {
    title: 'Trends & Growth',
    content_views: 'Content Views',
    learner_growth: 'Learners',
    total_learning_time: 'Total Learning Time',
    total_learning_time_tooltip: 'Total time your learners spent engaging with your video content.',
    avg_learning_time: 'Average Learning Time',
    avg_learning_time_tooltip: 'Average time each active learner spent on your video content.'
  },
  filters: {
    all_channels: "All Channels",
    embed: "Embed",
    share_links: "Share Links",
    in_app_tutorials: "In-App Tutorials",
    knowledge_hub: "Knowledge Hub",
    academy: "Academy"
  }
};
